// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a file for a return order to the remote API.
 *
 * @param id - The ID of the return order for which to upload the file.
 * @param file - The file to upload.
 */
export async function uploadReturnOrderFile(id: string, file: File) {
  return uploadFile(file, {
    context: 'RETURN_ORDER_FILE',
    isPublic: false,
    entityId: id,
  });
}
